<template>
  <div class="collection" @touchmove="preLoad(getPre)">
    <tab :line-width="1" custom-bar-width="60px" active-color="#027CFA">
      <tab-item
        :selected="item == '课程'"
        @on-item-click="onItemClick"
        v-for="item in tabs"
        :key="item.id"
      >
        {{ item }}
      </tab-item>
    </tab>
    <div class="scroll_div" ref="scroll_div">
      <default-page v-if="showDefaultPage"></default-page>

      <component
        :is="componentName"
        style="padding: 0 .4rem"
        :list="collectionCourseList"
      ></component>
    </div>
    <p
      style="text-align:center;margin-top: 1rem"
      v-show="!collectionCourseList.length && !showDefaultPage"
    >
      <inline-loading></inline-loading>
      <span style="vertical-align:middle;display:inline-block;font-size:14px;">
        &nbsp;&nbsp;加载中
      </span>
    </p>
  </div>
</template>
<script>
// TODO: vux
import { Spinner, Tab, TabItem, LoadMore } from 'vux';
import ListForImgAndText from '@/components/Headline/list.vue';
import HomeHotCourseList from '@/components/Course/List.vue';
import { personal } from '@/api/ajax.js';
import { loadMore } from '@/Mixin/loadMore.js';
export default {
  name: '',
  mixins: [loadMore],
  data() {
    return {
      componentName: 'HomeHotCourseList',
      tabs: ['课程', '头条'],
      collectionCourseList: [],
      data: {
        pageNo: 1,
        pageSize: 20,
        type: 4
      },
      loadFlag: true,
      urls: '/rest/ysh/wx/userCenter/queryChannelSubscribe' //http 请求
    };
  },
  methods: {
    moreList(data) {
      if (this.loadFlag) {
        this.loadFlag = false;
        this.$http.post(this.urls, data).then(res => {
          let resp = res.data.data;
          if (!this.collectionCourseList.length && !resp.list.length) {
            this.showDefaultPage = true;
          } else {
            this.showDefaultPage = false;
          }
          for (var i = 0; i < resp.list.length; i++) {
            this.collectionCourseList.push(resp.list[i]);
          }
          if (resp.list.length < this.data.pageSize) {
            this.loadFlag = false;
            return false;
          }
          this.data.pageNo += 1;
          this.loadFlag = true;
        });
      }
    },
    getPre() {
      this.moreList(this.data);
    },
    info(url, component) {
      this.data.pageNo = 1;
      this.collectionCourseList = [];
      this.loadFlag = true;
      this.urls = url;
      this.getPre();
      this.componentName = component;
    },
    //TABITEM点击
    onItemClick(index) {
      if (index == 1) {
        this.data.type = 1;
        this.info(
          '/rest/ysh/wx/userCenter/queryChannelSubscribe',
          'ListForImgAndText'
        );
      } else {
        this.data.type = 4;
        this.info(
          '/rest/ysh/wx/userCenter/queryChannelSubscribe',
          'HomeHotCourseList'
        );
      }
    }
  },
  computed: {},
  components: {
    Spinner,
    Tab,
    TabItem,
    LoadMore,
    ListForImgAndText,
    HomeHotCourseList
  },
  mounted() {
    this.getPre();
  }
};
</script>
<style lang="less">
.collection {
  .vux-tab-item {
    font-size: 0.3733rem !important;
  }
  .vux-tab-ink-bar {
    height: 2px !important;
  }
}
</style>
<style lang="less" scoped>
.scroll_div {
  margin-top: 0.3rem;
}
</style>
